import { UploadLink } from "@/__generated__/graphql.ts";

export async function uploadFiles(
  files: File[],
  uploadUrls: UploadLink[],
): Promise<void> {
  const clonedFiles = [...files];
  await Promise.all(
    uploadUrls.map(async (uploadLink) => {
      let file: undefined | File;
      for (let i = 0; i < clonedFiles.length; i++) {
        if (clonedFiles[i].name.includes(uploadLink.fileExtension)) {
          file = clonedFiles[i];
          clonedFiles.splice(i, 1);
          break;
        }
      }

      if (file !== undefined) {
        const response = await fetch(uploadLink.uploadUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (!response.ok) {
          throw new Error(
            `Upload failed: ${response.status} ${response.statusText}`,
          );
        }

        return response;
      }

      return Promise.reject(new Error("Upload file does not exist"));
    }),
  );
}

export const uploadFileToUrl = async (
  file: File,
  uploadUrl: string,
): Promise<void> => {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (!response.ok) {
    throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
  }
};
export const getMimeTypeFromFileName = (fileName: string) => {
  const extension = fileName.split(".").pop()?.toLowerCase();
  const mimeTypes: Record<string, string> = {
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
  };

  return mimeTypes[extension || ""] || "application/octet-stream";
};

export const downloadFile = async (url: string): Promise<File> => {
  const response = await fetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error(
      `Download failed: ${response.status} ${response.statusText}`,
    );
  }

  const blob = await response.blob();

  const fileName = decodeURIComponent(
    new URL(url).pathname.split("/").pop() || "file",
  );

  const mimeType =
    blob.type === "multipart/form-data"
      ? getMimeTypeFromFileName(fileName)
      : blob.type;

  const file = new File([blob], fileName, {
    type: mimeType,
  });

  return file;
};
